import { FieldType } from '@teable/core';

export const UNCATEGORIZED_STACK_ID = 't_kanban_uncategorized';
export const UNCATEGORIZED_STACK_NAME = 'Uncategorized';
export const UNCATEGORIZED_STACK_EMAIL = 'unknown@teable.io';

export const KANBAN_STACK_DISABLED_FIELD_TYPES = [FieldType.Attachment];
